module.exports = __webpack_public_path__ + "img/head.075ae5d7.jpeg";